/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback } from 'react';
import * as XLSX from 'xlsx';

interface IData {
  [key: string]: any;
}

interface IAllData {
  id?: string;
  data: IData[];
  columns: IData[];
  fileName?: string;
  className?: string;
  onClick?: () => Promise<IData[]>;
}

const ExportXls: React.FC<IAllData> = ({
  id,
  columns,
  fileName,
  className,
  onClick,
}) => {
  const handleClick = useCallback(
    async (e) => {
      e.preventDefault();

      let rawData: IData[] = [];
      if (onClick) {
        rawData = await onClick();
      }

      // Deriva colunas extras diretamente dos dados retornados, pois o estado
      // React (columnsCsv) pode ainda não ter sido atualizado neste momento.
      const allKeys = Array.from(
        new Set(rawData.flatMap((item) => Object.keys(item)))
      );
      const extraKeys = allKeys.filter(
        (key) => !columns.find((col) => col.selector === key)
      );
      const effectiveColumns = [
        ...columns,
        ...extraKeys.map((key) => ({ name: '', selector: key })),
      ];

      const mappedData = rawData.map((item: any) => {
        const newItem: { [key: string]: string } = {};
        Object.entries(item).forEach(([key, value], index) => {
          const columnSelected = effectiveColumns.find(
            (column) => column.selector === key
          );
          if (columnSelected) {
            if (!columnSelected.name) {
              newItem[`Extra ${String.fromCharCode(65 + index - 10)}`] =
                value as any;
            } else {
              newItem[columnSelected.name] = value as any;
            }
          }
        });
        return newItem;
      });

      const worksheet = XLSX.utils.json_to_sheet(mappedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');
      XLSX.writeFile(workbook, `${fileName || 'export'}.xlsx`);
    },
    [onClick, columns, fileName]
  );

  return (
    <button
      id={id}
      type="button"
      className={`${className} mt-3 mt-sm-0 mb-0 h6 fw-normal text-white btn-new px-5 py-2`}
      onClick={handleClick}
    >
      Exportar .XLS
    </button>
  );
};

export default ExportXls;
